<template>
    <option value="noaa-20-viirs-c2">VIIRS 375m NOAA-20 | km</option>
</template>
